import MuiCircularProgress from '@mui/material/CircularProgress';
import MuiLinearProgress from '@mui/material/LinearProgress';
import { SxProps } from '@mui/system';

import { Box } from './Box';
import { Typography, TypographyProps } from './Typography';

interface LoaderProps {
  size?: 'small' | 'medium' | 'large' | 'giant';
  label?: string;
  variant?: 'circular' | 'linear';
  sx?: SxProps;
}

export const Loader: React.FC<LoaderProps> = ({
  label,
  size = 'small',
  variant = 'circular',
  sx,
  ...props
}) => {
  const sizes = {
    small: 20,
    medium: 40,
    large: 60,
    giant: 120,
  };
  const gapSizeMap = {
    small: 2,
    medium: 3,
    large: 4,
    giant: 5,
  };
  const typographyVariantMap = {
    small: 'caption' as TypographyProps['variant'],
    medium: 'caption' as TypographyProps['variant'],
    large: 'body2' as TypographyProps['variant'],
    giant: 'body1' as TypographyProps['variant'],
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap={gapSizeMap[size]}
      sx={{ minWidth: '100px', width: '100%', ...sx }}
    >
      {variant === 'circular' && (
        <MuiCircularProgress color="primary" size={sizes[size]} {...props} />
      )}
      {variant === 'linear' && (
        <Box sx={{ width: '100%' }}>
          <MuiLinearProgress color="primary" {...props} />
        </Box>
      )}
      {label && (
        <Typography color="textSecondary" variant={typographyVariantMap[size]}>
          {label}
        </Typography>
      )}
    </Box>
  );
};
